var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationmarkTriangleFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.31 3.75c-.582-1-2.038-1-2.62 0l-8.735 15c-.582 1 .146 2.25 1.31 2.25h17.47c1.165 0 1.892-1.25 1.31-2.25l-8.735-15zM12 8.25c.69 0 1.25.56 1.25 1.25l-.44 5.502a.812.812 0 01-1.62 0L10.75 9.5c0-.69.56-1.25 1.25-1.25zm1 9.25a1 1 0 11-2 0 1 1 0 012 0z"
  })));
}
export default SvgExclamationmarkTriangleFill;